import { useEffect, useState, useRef } from 'react';

export function useIntersectionObserver(ref, margin="0px") {
  const [isOnScreen, setIsOnScreen] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(([entry]) =>{
        setIsOnScreen(entry.isIntersecting)
    },{rootMargin: margin});
  }, []);

  useEffect(() => {
    observerRef.current.observe(ref.current);

    return () => {
      observerRef.current.disconnect();
    };
  }, [ref]);

  return isOnScreen;
}
